import React, { useContext, useEffect, useRef, useState } from "react";

import { Text, View, Image, Platform, TouchableOpacity, FlatList, Modal, Animated, Alert, ImageResizeMode, LayoutAnimation } from "react-native";
import AppTheme from "../../utils/Theme";
import ComponentProps from "../../../specific/utils/Interfaces/ComponentProps";
import ActivityIndicator from "../../designSystem/ActivityIndicator/ActivityIndicator";
import { pop, push } from "../../../specific/utils/Navigation/Navigation";
import { useNavigate, useParams } from "../../../specific/utils/Navigation/Navigation";
import { getLocalActivities, getLocalActivitiesBySections, getLocalCategories } from "../../../specific/utils/LocalStorage";
import i18n, { getLanguage } from "../../utils/Localization/Localization";
import { default as IcBack } from "../../assets/svg/lili/ic_back_arrow.svg";
import Images from "../../../specific/utils/Images";
import CategoryHomeStyle from "../../styles/categories/CategoryHomeStyle";
import MainStyle from "../../styles/game/MainStyle";
import User from "../../data/user/User";
import { ScreenCategoryHome } from "../../utils/Constants";
import Activity from "../../models/Activity";
import CategoryIcon from "../Categories/CategoryIcon";
import { replaceCustomVariablesInString } from "../../utils/StringUtils";
import { default as IcFilter } from "../../assets/svg/lili/ic_filter.svg";
import { build } from "../../../../package.json";

import * as Navigation from "../../../specific/utils/Navigation/Navigation";

import { LocalDBContext } from "../../data/LocalDB";
import Divider from "../../designSystem/Divider/Divider";
import CategoryHome from "../Categories/CategoryHome";
import InViewModal from "../../../specific/components/InViewModal/InViewModal";
import DeepLink from "../../services/DeepLink/DeepLink";

import TipsButton from "../TipsButton/TipsButton";
import Tips from "../../models/Tips";
import NavBarButton from "../NavBar/NavBarButton";
import UserLevelSelection from "../Filters/UserLevelSelection";
import NavBar from "../../../specific/components/NavBar/NavBar";
import Main from "../../../specific/components/Main/Main";
import MainOptions from "../../models/MainOptions";
import { IcClose } from "../../utils/Icons";
import ActivityCellTitle from "../Activities/ActivityCells/ActivityCellTitle";

interface SectionCategoriesProps extends ComponentProps {
    sectionKey?: string,
    isModal?: boolean
}

export const headerImages = {
    "still": "headerSectionStill",
    "talk": "headerSectionTalk",
    "grow": "headerSectionGrow",
    "inspire": "headerSectionInspire"
}

const SectionCategories = (props: SectionCategoriesProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const categoryHomeStyle: CategoryHomeStyle = new CategoryHomeStyle();
    const user: User = User.getInstance();

    const [viewDidAppear, setViewDidAppear] = useState<boolean>(false);
    const [categories, setCategories] = useState<any>(undefined);
    const [localCategories, setLocalCategories] = useState<any>(undefined);
    const [section, setSection] = useState<any>(undefined);
    const [showLevelSelection, setShowLevelSelection] = useState<boolean>(false);

    const [localActivities, setLocalActivities] = useState(undefined);
    const [selectedCategory, setSelectedCategory] = useState<string | undefined>(undefined);

    const contentViewOpactiy: Animated.Value = useRef(new Animated.Value(1)).current;

    const localDBData = useContext(LocalDBContext);

    const inViewModal = useRef<InViewModal>(null);

    let propsData = props;
    if (Platform.OS === "web") {
        if ((props.isModal === undefined) || ((props.isModal !== undefined) && (props.isModal === false))) {
            propsData = useParams();
        }
    }
    let navigate: any = null;
    if (Platform.OS === "web") {
        navigate = useNavigate();
    }

    const { sectionKey, componentId, isModal = false } = propsData;
    console.log({ propsData });

    useEffect(() => {
        if (section !== undefined) {
            getSectionCategories();
        }
    }, [section]);

    const onViewDidAppear = () => {
        console.log({ sectionKey });
        if ((sectionKey !== undefined) && (sectionKey.length > 0)) {
            // On va récupérer les données de la catégorie
            const sections = localDBData.sections.data;
            console.log({ localDBData });
            if (sections[sectionKey] !== undefined) {
                setSection(sections[sectionKey]);
            } else {
                goBack();
            }
        } else {
            // Erreur de lien on revient en arrière
            goBack();
        }
    }

    const getSectionCategories = async () => {
        const localActivitiesBySectionsFromStorage = await getLocalActivitiesBySections();
        console.log({ localActivitiesBySectionsFromStorage });
        if (localActivitiesBySectionsFromStorage.data[sectionKey] !== undefined) {
            setCategories(localActivitiesBySectionsFromStorage.data[sectionKey]);
        } else {
            goBack();
        }
    }

    useEffect(() => {
        if (categories !== undefined) {
            getActivities();
        }
    }, [categories]);

    const getCategoryDetails = async () => {
        const localCategoriesFromStorage = await getLocalCategories();
        let localCategoriesOrdered = [];
        for (const aCategoryKey in categories) {
            if (Object.prototype.hasOwnProperty.call(categories, aCategoryKey)) {
                if (localCategoriesFromStorage.data[aCategoryKey] !== undefined) {
                    const aCategory = localCategoriesFromStorage.data[aCategoryKey];
                    const categoryMinBuildNumber = aCategory.minBuildNumber ?? "0";
                    if ((aCategory.status === "published") && (parseInt(categoryMinBuildNumber) < parseInt(build))) {
                        let isCategoryInserted: boolean = false;
                        let insertTheCategory: boolean = false;
                        // On va regarder si la catégorie contient au moins une activité à destination des enfants "cibles"
                        if ((categories[aCategoryKey] !== undefined) && (categories[aCategoryKey].length > 0)) {
                            for (const anActivityIndex in categories[aCategoryKey]) {
                                if (Object.prototype.hasOwnProperty.call(categories[aCategoryKey], anActivityIndex)) {
                                    const anActivityKey: string = categories[aCategoryKey][anActivityIndex];
                                    if (localActivities[anActivityKey] !== undefined) {
                                        if (localActivities[anActivityKey].cycles !== undefined) {
                                            if (localActivities[anActivityKey].cycles.indexOf(user.children_level) !== -1) {
                                                // On a au moins une activité
                                                insertTheCategory = true;
                                                break;
                                            }
                                        } else {
                                            insertTheCategory = true;
                                            break;
                                        }

                                    }
                                }
                            }
                        }
                        if (insertTheCategory === true) {
                            for (const anOrderedCategoryIndex in localCategoriesOrdered) {
                                if (Object.prototype.hasOwnProperty.call(localCategoriesOrdered, anOrderedCategoryIndex)) {
                                    const anOrderedCategory = localCategoriesOrdered[anOrderedCategoryIndex];
                                    if (anOrderedCategory.ord > aCategory.ord) {
                                        localCategoriesOrdered.splice(parseInt(anOrderedCategoryIndex), 0, aCategory);
                                        isCategoryInserted = true;
                                        break;
                                    }
                                }
                            }
                            if (isCategoryInserted === false) {
                                localCategoriesOrdered.push(aCategory);
                            }
                        }
                    }
                }
            }
        }
        setLocalCategories(localCategoriesOrdered);
    }

    useEffect(() => {
        if (localCategories !== undefined) {
            // On va regarder si on a des critères de deeplink
            const deeplink: DeepLink = DeepLink.getInstance();
            if (deeplink.category_key.length > 0) {
                showCategorySheet({ categoryKey: deeplink.category_key });
                deeplink.category_key = "";
            }
            setViewDidAppear(true);
        }
    }, [localCategories])

    const getActivities = async () => {
        const localActivitiesFromStorage = await getLocalActivities();
        setLocalActivities(localActivitiesFromStorage.data);
    }

    useEffect(() => {
        if (localActivities !== undefined) {
            getCategoryDetails();
        }
    }, [localActivities]);

    const getCategoryColors = () => {
        let defaultColors = {
            btn: appTheme.daySkyColor,
            header_bg: appTheme.daySkyColor,
            nav: appTheme.daySkyColor,
            txt: appTheme.white
        };
        let categoryColors = defaultColors;
        if (sectionKey === "still") {
            categoryColors = {
                btn: appTheme.still,
                header_bg: appTheme.still,
                nav: "#A2F2F8",
                txt: appTheme.darkBlue
            }
        } else if (sectionKey === "talk") {
            categoryColors = {
                btn: appTheme.talk,
                header_bg: "#FFAA8C",
                nav: appTheme.talk,
                txt: appTheme.white
            }
        } else if (sectionKey === "grow") {
            categoryColors = {
                btn: appTheme.grow,
                header_bg: "#51D2A8",
                nav: appTheme.grow,
                txt: appTheme.white
            }
        } else if (sectionKey === "super_program") {
            categoryColors = {
                btn: appTheme.darkBlue,
                header_bg: appTheme.darkBlue,
                nav: appTheme.darkBlue,
                txt: appTheme.white
            }
        } else if (sectionKey === "inspire") {
            categoryColors = {
                btn: section.clr.main,
                header_bg: section.clr.action,
                nav: section.clr.main,
                txt: "#25364f"
            }
        }
        return categoryColors;
    }

    const goBack = () => {
        if ((Platform.OS !== "web") && (isModal === true)) {
            Navigation.dismissModal({ componentId, navigate });
        } else {
            pop({ componentId, navigate });
        }
    }

    useEffect(() => {
        let contentViewOpactiyFinalValue = selectedCategory === undefined ? 1 : 0;
        Animated.timing(contentViewOpactiy, {
            toValue: contentViewOpactiyFinalValue,
            duration: 500,
            useNativeDriver: false
        }).start();
    }, [selectedCategory]);

    const showCategorySheet = (data: { categoryKey: string }) => {
        const { categoryKey } = data;
        let passProps = {
            categoryKey: categoryKey,
            sectionKey,
            starting_point: "section",
            section: sectionKey,
            origin: "menu"
        }
        if ((Platform.OS === "web") && (isModal === true)) {
            Navigation.showModalInView({
                componentId,
                navigate,
                name: ScreenCategoryHome,
                passProps
            })
        } else {
            push({
                componentId,
                navigate,
                name: ScreenCategoryHome,
                passProps
            });
        }

    }

    const categoriesGridCell = ({ item, index }) => {
        const refWidth = appTheme.getFlexDirectionForSplitScreen() === "column" ? appTheme.getFullAppWidth() : appTheme.getBlockWidth() - appTheme.pixelPerfect(100);
        let cellSize = (refWidth - appTheme.pixelPerfect(60)) / 3;
        const marginHorizontal = appTheme.pixelPerfect(10);
        let imageSize = appTheme.pixelPerfect(80);
        if (imageSize > (cellSize - appTheme.pixelPerfect(10))) {
            imageSize = cellSize - appTheme.pixelPerfect(10);
        }
        const marginTop = Platform.OS === "web" ? 0 : appTheme.pixelPerfect(10);
        const textFontSize = Platform.OS === "web" ? appTheme.pixelPerfectForFont(10) : appTheme.pixelPerfectForFont(6);


        let activityImage: string | undefined = undefined;
        let remotePath: string | undefined = undefined;
        if (item.icon !== undefined) {
            activityImage = item.icon.app;
            remotePath = item.icon.db;
        } else {
            // On va chercher l'image de la première activité de la catégorie
            const firstActivityKey = categories[item.key][0] !== undefined ? categories[item.key][0] : undefined;
            if (localActivities[firstActivityKey] !== undefined) {
                const anActivity: Activity = localActivities[firstActivityKey];
                if ((anActivity.img_url !== undefined) && (anActivity.img_url.length > 0)) {
                    remotePath = anActivity.img_url;
                }
                if ((anActivity.app_image !== undefined) && (anActivity.app_image.length > 0) && (images[anActivity.app_image] !== undefined)) {
                    activityImage = anActivity.app_image;
                }
            }
        }

        const categoryColor = getCategoryColors();
        let flexDirection = "column";
        let textAlign = "center";
        let paddingHorizontal = 0;
        return <TouchableOpacity key={item.key} onPress={() => showCategorySheet({ categoryKey: item.key })} style={{ flexDirection, marginTop, marginHorizontal, alignItems: "center", width: cellSize }}>
            <CategoryIcon color={categoryColor.btn} localPath={activityImage} remotePath={remotePath} size={appTheme.pixelPerfect(80)} />
            <View style={{ marginTop: appTheme.pixelPerfect(5), width: "80%", justifyContent: "flex-start", flex: 1, paddingHorizontal }}>
                <Text numberOfLines={3} style={{ fontFamily: appTheme.primaryBoldFont, color: appTheme.darkBlue, textAlign, fontSize: appTheme.pixelPerfectForFont(7) }}>{item.title[getLanguage()]}</Text>
            </View>
        </TouchableOpacity>
    }

    const getActivitiesGrid = () => {
        const lineWidth = appTheme.getFlexDirectionForSplitScreen() === "column" ? appTheme.getBlockWidth() : appTheme.getBlockWidth() - appTheme.pixelPerfect(100);
        let categoriesGrid = [];
        let categoriesLine = [];
        const activitiesByLine = 3;
        const marginBottom = appTheme.pixelPerfect(40);
        categoriesGrid.push(<Divider />);
        for (const aCategoryIndex in localCategories) {
            if (Object.prototype.hasOwnProperty.call(localCategories, aCategoryIndex)) {
                const aCategory = localCategories[aCategoryIndex];
                categoriesLine.push(categoriesGridCell({ item: aCategory, index: aCategoryIndex }));
                if (categoriesLine.length === activitiesByLine) {
                    categoriesGrid.push(<View style={{ flexDirection: "row", alignItems: "flex-start", width: lineWidth, marginBottom }}>
                        {categoriesLine}
                    </View>);
                    categoriesLine = [];
                }
            }
        }
        if (categoriesLine.length > 0) {
            categoriesGrid.push(<View style={{ flexDirection: "row", alignItems: "flex-start", width: lineWidth }}>
                {categoriesLine}
            </View>);
        }
        return <Animated.View style={[categoryHomeStyle.contentView, { opacity: contentViewOpactiy, overflow: "hidden" }]}>
            {categoriesGrid}
        </Animated.View>
    }

    const getListHeader = (addBorderRadius?: boolean) => {
        let borderRadius: number = ((addBorderRadius !== undefined) && (addBorderRadius === true)) ? appTheme.pixelPerfect(10) : 0;
        let headerBgColor = section.key === "superPowers" ? appTheme.darkBlue : undefined;
        const clr = getCategoryColors();
        if (headerBgColor === undefined) {
            headerBgColor = clr.header_bg;
        }
        let headerImageView = <View style={categoryHomeStyle.headerImage(appTheme.white)} />;
        let source: any = images[headerImages[sectionKey]];
        let imageWidth: number = ((Platform.OS === "web") && (isModal === true)) ? appTheme.getBlockWidth() - appTheme.pixelPerfect(20) : appTheme.getFullAppWidth()
        let imageHeight: number = imageWidth * 27 / 36;
        let resizeMode: ImageResizeMode = "cover";
        if (Platform.OS === "web") {
            imageHeight = imageWidth * 35 / 192;
            resizeMode = "contain";
        }
        if (source !== undefined) {
            headerImageView = <Image source={source} style={[categoryHomeStyle.headerImage(headerBgColor), { width: imageWidth, height: imageHeight, borderRadius }]} resizeMode={resizeMode} />;
        }
        return <View style={{ width: ((Platform.OS === "web") && (isModal === true)) ? appTheme.getBlockWidth() : appTheme.getFullAppWidth(), alignItems: "center" }}>
            {headerImageView}
        </View>
    }

    const getCategoriesList = () => {
        if (Platform.OS === "web") {
            return getActivitiesGrid()
        } else {
            return <FlatList
                numColumns={3}
                ListHeaderComponent={getListHeader}
                data={localCategories}
                style={{ width: appTheme.getFullAppWidth(), backgroundColor: appTheme.white }}
                renderItem={categoriesGridCell}
                keyExtractor={(index, item) => item.key} />
        }
    }

    const getModalContent = () => {
        if (Platform.OS === "web") {
            if ((viewDidAppear === true) && (selectedCategory !== undefined)) {
                return <View style={[categoryHomeStyle.modalStyle, { top: 0 }]}>
                    <CategoryHome starting_point="section" sectionKey={sectionKey} header={headerImages[sectionKey]} isModal={true} categoryKey={selectedCategory} webCloseRequest={() => setSelectedCategory(undefined)} />
                </View>
            }
        }
        return <View />;
    }

    const onToggleFilters = () => {
        setShowLevelSelection(false);
    }

    const renderNavBar = () => {
        const tips: Tips = Tips.getInstance();
        const { title, key } = section;
        const clr = getCategoryColors();
        if ((Platform.OS === "web") && (isModal === false)) {
            return <NavBar sectionkey={key} categoryColors={clr} tips={tips.sections} title={title[getLanguage()]} />;
        }

        let navBarColor = clr.nav;
        let navBarTextColor = clr.txt;
        let titleToDisplay = replaceCustomVariablesInString(title[getLanguage()]);
        const titlesHorizontalAlign: string = "flex-start";
        const titleSuperHeroFontSize: number = appTheme.pixelPerfectForFont(9);
        let tipsButton: React.JSX.Element = <View />;
        if (tips.sections !== undefined) {
            if (tips.sections[sectionKey] !== undefined) {
                tipsButton = <TipsButton color={navBarColor} style={{ marginEnd: appTheme.pixelPerfect(10) }} tips={tips.sections[sectionKey]} />;
            }
        }
        const levelTitle: string = user.profile === "teacher" ? i18n.t("levels." + user.children_level) : i18n.t("filters." + user.children_level);
        if ((Platform.OS === "web") && (isModal === true)) {
            return <View style={{ flex: 1, alignItems: "center", paddingVertical: appTheme.pixelPerfect(10) }}>
                <Text style={{ color: navBarTextColor, fontFamily: appTheme.superHerosFontBold, fontSize: titleSuperHeroFontSize }}>{titleToDisplay.replace("\\n", "\n")}</Text>
                <Text style={{ color: navBarTextColor, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }}>{levelTitle.toLocaleLowerCase()}</Text>
            </View>
        }
        return <View style={{ position: "absolute", flexDirection: "row", width: appTheme.getFullScreenWidth(), paddingTop: appTheme.topInsets, alignItems: "center", paddingHorizontal: appTheme.pixelPerfect(10), height: appTheme.pixelPerfect(60) + appTheme.topInsets, backgroundColor: navBarColor }}>
            <NavBarButton style={{ marginEnd: appTheme.pixelPerfect(10) }} icon={IcBack} action={goBack} />
            <View style={{ flex: 1, alignItems: titlesHorizontalAlign }}>
                <Text style={{ color: navBarTextColor, fontFamily: appTheme.superHerosFontBold, fontSize: titleSuperHeroFontSize }}>{titleToDisplay.replace("\\n", "\n")}</Text>
                <Text style={{ color: navBarTextColor, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }}>{levelTitle.toLocaleLowerCase()}</Text>
            </View>
            {tipsButton}
            <NavBarButton icon={IcFilter} action={() => setShowLevelSelection(true)} />
        </View>
    }

    const getContent = () => {
        if (viewDidAppear === false) {
            return <View onLayout={onViewDidAppear} style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                <ActivityIndicator loading={true} color={appTheme.darkBlue} />
            </View>
        }

        let headerBgColor = section === "superPowers" ? appTheme.darkBlue : undefined;
        if (headerBgColor === undefined) {
            const clr = getCategoryColors();
            headerBgColor = clr.header_bg;
        }

        const listHeader = Platform.OS === "web" ? getListHeader() : <View />;
        return <View style={categoryHomeStyle.mainView(headerBgColor)}>
            <View style={categoryHomeStyle.mainBackground(headerBgColor)} />
            {listHeader}
            {getCategoriesList()}
            {getModalContent()}
            {renderNavBar()}
            <InViewModal ref={inViewModal} />
            <UserLevelSelection
                visible={showLevelSelection}
                style={{ flex: 1, justifyContent: "flex-end" }}
                backgroundColor={appTheme.schoolColor}
                toggleFilters={onToggleFilters} />
        </View>
    }

    const getContentAsModalView = () => {
        if (viewDidAppear === false) {
            return <View onLayout={onViewDidAppear} style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                <ActivityIndicator loading={true} color={appTheme.darkBlue} />
            </View>
        }
        let headerBgColor = section === "superPowers" ? appTheme.darkBlue : undefined;
        if (headerBgColor === undefined) {
            const clr = getCategoryColors();
            headerBgColor = clr.header_bg;
        }
        return <View style={{ width: appTheme.getBlockWidth(), flex: 1, backgroundColor: "#FFFFFF", marginVertical: appTheme.pixelPerfect(10), paddingVertical: appTheme.pixelPerfect(10), borderRadius: appTheme.pixelPerfect(10) }}>
            <View>
                {getListHeader(true)}
                <View style={{ position: "absolute", top: appTheme.pixelPerfect(5), left: appTheme.pixelPerfect(15) }}>
                    <NavBarButton action={() => {
                        Navigation.dismissModalInView({ componentId, navigate });
                    }} icon={IcClose} />
                </View>
            </View>
            {renderNavBar()}
            {getCategoriesList()}
        </View>
    }

    if ((Platform.OS === "web") && (isModal === true)) {
        return getContentAsModalView()
    }

    return getContent();
}

export default SectionCategories;